<template>
  <v-radio-group
    v-model="type"
    color="primary"
    @change="$emit('update:sectionType', type)"
  >
    <div v-for="(choice, index) in choices" :key="index">
      <v-radio :label="choice.label" :value="choice.value"></v-radio>
      <v-text-field
        v-if="sectionType === choice.value"
        v-model="name"
        :label="$t('message.storeLocator.extraInfo.sectionName')"
        @change="$emit('update:sectionName', name)"
      ></v-text-field>
    </div>
  </v-radio-group>
</template>

<script>
export default {
  name: "SectionSelectForm",
  props: {
    sectionType: String,
    sectionName: String,
    choices: {
      type: Array,
      required: true
    }
  },
  created() {
    this.type = this.sectionType;
    this.name = this.sectionName;
  },
  data() {
    return {
      type: null,
      name: null
    };
  }
};
</script>
